<template>
    <transition name="modal">
        <div id="addUserToTalkgroup" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-t="'message.title_two_phase_auth_user_search'">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr class="dialoginputfield">
                            <td colspan=2>
                                <div style="padding: 10px;">
                                    <el-form @submit.native.prevent="findUser()">
                                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchName" clearable class="object-search-select">
                                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                                <el-option :label="$t('message.item_userId')" value="loginName"></el-option>
                                                <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                            </el-select>
                                            <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                        </el-input>
                                    </el-form>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="'inner-panel-dialog-narrow'">
                                    <table width="100%">
                                        <tr height="36px" class="object-titlebox">
                                            <td width="20%" valign="top" class="information-header" v-t="'message.item_userId_displayName'"></td>
                                            <td width="15%" valign="top" class="information-header" v-t="'message.item_two_phase_method_setting'"></td>
                                            <td width="15%" valign="top" class="information-header" v-t="'message.item_tenant_admin'"></td>
                                            <td width="25%" valign="top" class="information-header" v-t="'message.item_two_phase_method_target_mail'"></td>
                                            <td width="18%" valign="top" class="information-header" v-t="'message.item_two_phase_method_target_update_date'"></td>
                                            <td width="15%" valign="top" class="information-header"></td>
                                        </tr>
                                        <tr class="object-titlebox" v-if="showResult">
                                            <td colspan="10">
                                                <div class="inner-panel">
                                                    <table width="100%">
                                                        <tr class="record" v-for="twoPhaseAuthInfo in twoPhaseAuthInfoList" :key="twoPhaseAuthInfo.userName" >
                                                            <td width="20%" class="two-phase-auth-info">
                                                                <span>{{ twoPhaseAuthInfo.userName  + " / " + twoPhaseAuthInfo.displayName }}</span>
                                                            </td>
                                                            <td width="15%" class="two-phase-auth-info">{{ twoPhaseAuthInfo.methodName }}</td>
                                                            <td width="15%" class="two-phase-auth-info">{{ displayRights(twoPhaseAuthInfo.rights) }}</td>
                                                            <td width="25%" class="two-phase-auth-info">{{ twoPhaseAuthInfo.email }}</td>
                                                            <td width="18%" class="two-phase-auth-info">{{ twoPhaseAuthInfo.formattedUpdateDate }}</td>
                                                            <td width="15%" v-if="twoPhaseAuthInfo.methodOption !== LOGIN_METHOD_NO_SETTING">
                                                                <button class="transparent-button" type="button" @click="checkACL(twoPhaseAuthInfo)">
                                                                    <span class="normal-command-text" v-t="'message.button_disable_two_phase_auth'"></span>
                                                                </button>
                                                            </td>
                                                            <td width="15%" v-else></td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_close'"></el-button>
                </div>
            </div>
            <!-- 警告ダイアログ　ユーザーの設定をリセット -->
            <el-dialog :visible.sync="showWarningDialog" width="30%" append-to-body>
                <div>
                    <span v-t="'message.item_user_name'"></span> : <span> {{ targetUserInfo.userName }}</span>
                </div>
                <div v-t="'message.warn_reset_two_phase_auth1'"></div>          
                <div v-if="targetUserInfo.methodOption==LOGIN_METHOD_GA" v-t="'message.warn_reset_ga_secret_key'" style="color: red;"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWarningDialogClose" v-t="'message.button_cancel'"></el-button>
                    <el-button type="primary" @click="handleWarningDialogOk" v-t="'message.button_ok'"></el-button>
                </span>
            </el-dialog>
        </div>
     </transition>
 </template>
 
 <script>
import Vue from 'vue'
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
 
 export default {
     data() {
       return {
            //CONST
            LOGIN_METHOD_NO_SETTING: constants.LOGIN_METHOD_NO_SETTING,
            LOGIN_METHOD_MAIL: constants.LOGIN_METHOD_MAIL,
            LOGIN_METHOD_GA: constants.LOGIN_METHOD_GA,

            condition: "loginName",
            searchName: "",
            twoPhaseAuthInfoList: [],
            targetUserInfo: {
                userId: 0,
                userName: "",
                methodOption: constants.LOGIN_METHOD_NO_SETTING,
            },
            showResult: false,
            disableSave: true,
            selectedTitle: commonUtil.getMessageText(this.$i18n,"title_groupUser"),
            showWarningDialog: false,
       };
     },
     methods: {
        findUser() { 
            const req = {
                searchName: this.searchName,
                condition: this.condition
            }
            let self = this;
            server.post('/getconsoletwophaseauthinfobyname', req)
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (res.data.hit) {
                                self.twoPhaseAuthInfoList = res.data.twoPhaseAuthInfoList;
                                self.mappingData();
                                self.showResult = true;
                            } else {
                                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                                self.showResult = false;
                            }
                            break;
                        case constants.STATUS_ERROR_PERMISSION_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"item_write_permission"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findUser").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "findUser", error);
                });
        },
        async resetTwoPhaseAuthInfoByUserId(userId, userName) {
            const request = {
                userId: userId,
                userName: userName,
                methodOption: constants.LOGIN_METHOD_NO_SETTING
            }
            const self = this;
            await server.post('/modifyconsoletwophasemethod', request)
            .then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        this.findUser();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","resetTwoPhaseAuthInfoByUserId").replace("{code}",res.data.status));
                        return;
                }
            })
            .catch((error) => {
                commonUtil.putExceptionErrorMessage(self, "resetTwoPhaseAuthInfoByUserId", error);
            });
        },
        getMethodName(value) {
            let messageKey;
            switch (value) {
                case constants.LOGIN_METHOD_MAIL:
                    messageKey = "item_value_two_pahse_auth_mail";
                    break;
                case constants.LOGIN_METHOD_GA:
                    messageKey = "item_value_two_pahse_auth_ga";
                    break;
                default:
                    messageKey = "item_value_notSet";
                    break;
            }
            return commonUtil.getMessageText(this.$i18n, messageKey);
        },
        displayRights(rights) {
            if(commonUtil.checkUserPrivilege(rights, constants.PRIVILEGE_TENANT_ADMIN)) {
                return "○";
            } else {
                return "-";
            }
        },
        mappingData() {
            this.twoPhaseAuthInfoList = this.twoPhaseAuthInfoList.map(info => ({
                ...info,
                methodName: this.getMethodName(info.methodOption),
                formattedUpdateDate: info.methodOption !== constants.LOGIN_METHOD_NO_SETTING 
                    ? this.formatDate(info.updateDate) 
                    : '',
                email: info.methodOption === constants.LOGIN_METHOD_MAIL 
                    ? info.email 
                    : '',
            }));
        },
        formatDate(date) {
            if(!date) return ""
            const utcDate = new Date(date);
            const locale = this.$i18n.locale === 'ja' ? 'Asia/Tokyo' : 'UTC';
            return utcDate.toLocaleString('ja-JP', { timeZone: locale }).replace(/\//g, '-').replace(/, /g, ' ');
        },
        checkACL(twoPhaseAuthInfo) {
            if (!twoPhaseAuthInfo.canReset) {
                commonUtil.notifyMessage(self, 'Error', commonUtil.getMessageText(self.$i18n, "info_two_phase_method_edited"));
                return;
            }
            this.displayWarningDialog(twoPhaseAuthInfo);
        },
        displayWarningDialog(twoPhaseAuthInfo) {
            this.targetUserInfo.userId = twoPhaseAuthInfo.userId;
            this.targetUserInfo.userName = twoPhaseAuthInfo.userName;
            this.targetUserInfo.methodOption = twoPhaseAuthInfo.methodOption;
            this.showWarningDialog = true;
        },
        async handleWarningDialogOk() {
            this.resetTwoPhaseAuthInfoByUserId(this.targetUserInfo.userId, this.targetUserInfo.userName);
            this.showWarningDialog = false;
        },
        handleWarningDialogClose() {
            this.showWarningDialog = false;
        },
     },
 }
 </script>
 
 
 <style scoped>
 .dialoginputfield {
     height: 60px;
 }
 
 .findedUser-record {
   cursor: pointer;
 }
 .findedUser-record:hover {
   background-color: #ecf1fa;
 }
 
 .findedUser {
   padding: 10px 20px;
 }
 
 .input-with-select >>> .el-input-group__prepend {
     background-color: #fff;
 }
 .input-with-select >>> .el-select .el-input {
     font-size: 14px;
     width: 120px;
 }
 .input-with-select >>> .el-button {
     width: 40px;
     padding: 0;
 }
 
 .el-input-group {
     width: 650px;
     padding-left: 20px;
     padding-bottom: 0;
 }
 
 .el-select-dropdown__item.selected {
     color: #000000;
 }
 
 .el-select-dropdown__item {
     font-size: 14px;
 }

.inner-panel-dialog-wide {
	position:relative;
    height: calc(80vh - 180px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}
.inner-panel-dialog-narrow {
	position:relative;
    height: calc(80vh - 240px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.foundUser-record {
  cursor: pointer;
}
.foundUser-record:hover {
  background-color: #ecf1fa;
}

.foundUser {
  padding: 10px 20px;
}

.information-header {
    padding: 10px 0 10px 20px;
    color: #848991;
    background-color:#f6f6f6;
    font-size: 12px;
}

.two-phase-auth-info {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    color: #848991;
}
 
 </style>
 